import { init } from "../init";
import { JiraSoftwarePage } from "../pages/jira-software-page";
init(JiraSoftwarePage);
